export default __webpack_public_path__ + "static/brooklyn-32876820a29693a25f30b83f4d46e19e.jpg";